import React from 'react';
import PropTypes from 'prop-types';
import I18n from 'app/config/i18n';
import ParamInfoIcon from 'app/backbone/lib/react/sensors/paramInfoIcon/paramInfoIcon';

const WifiSignalLevel = (props) => (
  <div className="signal">
    <ParamInfoIcon
      value={props.value}
      displayValue={props.networkName}
      noValueText={I18n.t('base.labels.n_a')}
      iconClass={`icon-wifi-signal-${props.level}`}
      title={props.title}
    />
  </div>
);

WifiSignalLevel.defaultProps = {
  title: '',
  value: '',
  noValueText: '',
  networkName: ''
};

WifiSignalLevel.propTypes = {
  title: PropTypes.string,
  value: PropTypes.any,
  noValueText: PropTypes.string,
  networkName: PropTypes.string,
  level: PropTypes.number.isRequired
};

export default WifiSignalLevel;
